import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'
import store from '../store'
import { clearAuth, getToken } from './auth'

function isPublicAuthRequest(url) {
  return url === '/api/admin/auth/login' || url === '/api/admin/auth/register'
}

const DEFAULT_API_BASE_URL = 'https://api.cdz7.cn'
export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL
  || DEFAULT_API_BASE_URL

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000
})

service.interceptors.request.use(config => {
  const token = getToken()
  if (token && !isPublicAuthRequest(config.url || '')) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

service.interceptors.response.use(
  response => {
    const res = response.data || {}
    const message = res.message || res.msg || '请求失败'
    if (res.code !== 0) {
      Message.error(message)
      if (message === 'Login required' || message === 'Admin permission required') {
        clearAuth()
        store.commit('resetState')
        router.replace('/login')
      }
      return Promise.reject(new Error(message))
    }
    return res.data
  },
  error => {
    const responseData = error && error.response && error.response.data
    const message = (responseData && (responseData.message || responseData.msg))
      || error.message
      || '网络异常'
    Message.error(message)
    return Promise.reject(error)
  }
)

export default service
